import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './rebut.reducer';

export const RebutDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const rebutEntity = useAppSelector(state => state.rebut.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="rebutDetailsHeading">
          <Translate contentKey="alexisExportApp.rebut.detail.title">Rebut</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{rebutEntity.id}</dd>
          <dt>
            <span id="datePersistence">
              <Translate contentKey="alexisExportApp.rebut.datePersistence">Date Persistence</Translate>
            </span>
          </dt>
          <dd>
            {rebutEntity.datePersistence ? <TextFormat value={rebutEntity.datePersistence} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="dateUpdate">
              <Translate contentKey="alexisExportApp.rebut.dateUpdate">Date Update</Translate>
            </span>
          </dt>
          <dd>{rebutEntity.dateUpdate ? <TextFormat value={rebutEntity.dateUpdate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="alexisExportApp.rebut.produit">Produit</Translate>
          </dt>
          <dd>{rebutEntity.produit ? rebutEntity.produit.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/rebut" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/rebut/${rebutEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RebutDetail;
